module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    attrs: {
      "header": "联系方式"
    }
  }, [_c('ul', [_c('li', [_vm._v("刘潋<lln1697@corp.netease.com>")]), _vm._v(" "), _c('li', [_vm._v("王琦<wqn1696@corp.netease.com>")]), _vm._v(" "), _c('li', [_vm._v("何广鹏<heguangpeng@corp.netease.com>")]), _vm._v(" "), _c('li', [_vm._v("吕景俊<jjlv@corp.netease.com>")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-ed261740!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Contact.vue
// module id = ILmE
// module chunks = 4